export interface PositionDTO {
  lat: number
  lng: number
}

export interface FlatPosition {
  latitude: number
  longitude: number
}

export function mapPositionToFlat(
  position: Partial<PositionDTO> | Record<string, number>,
): FlatPosition {
  return {
    latitude: Number(position.lat ?? 0),
    longitude: Number(position.lng ?? 0),
  }
}

export function mapFlatToPosition(position: FlatPosition): PositionDTO {
  return {
    lat: Number(position.latitude),
    lng: Number(position.longitude),
  }
}
